import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  SalesOrderService,
  ComboService
} from "../../../services/index";

@Component({
  selector: "addEdit-SalesReturn-Bundle",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditCommission.html",
})
export class addEditCommission {
  teamList = ["PRIME", "PREMIUM"];
  list = [];
  agentList = [];
  mode : string;
  saveEvent: any;
  isLoading: boolean = false;
  partyList = [];
  checklist = [];
  masterData: any = {
    ref_no: 0,
    date: new Date(),
    team:'',
    agent:'',
    agent_id:0,
    ab_below :0,
    bel_withbox:0,
    bel_wo_box :0,
    above_withbox:0,
    above_wo_box:0,
    effective_from : new Date()
  };
  agentData= [];
  // agentDetails= {
  //   from : '',
  //   to:'',
  //   commission:''

  // }

  @Input() _params: any;
  @Input() active = false;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
  
    if (this.mode == "View") {
      this.viewCommissionlist(designdata.com_id)
      this.masterData = designdata;
      this.masterData.agent = designdata.agent_name;
      this.masterData.ref_no = designdata.ref_no;
     
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,

  ) {}
  ngOnInit() {
    for(var i = 0; i < 7 ; i++){
     let val = '';
     if(i == 0){
     val = '1';

     }
     else{
      val = ''
     }
    this.agentData.push({
      from_days: val,
      to_days: '',
      commission:'',
      per_detect:''


    })

    }
    this.getPartyList();
 
    this.getAgentList();
    if(this.mode == "Add"){
    this.getMasterAuto()
    this.getcommissionMasterList();

    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#ret_date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else  {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);

    }
  }
  onGoToNextFld($event, fld, ind) {

    let agentDetails= {
      from_days : '',
      to_days:'',
      commission:'',
      per_detect:''
  
    }
    if(ind === this.agentData.length-1 && this.agentData[this.agentData.length-1]['to_days'] ){
      this.agentData.push(agentDetails);
    
    }
     if(this.agentData[ind]['from_days'] > this.agentData[ind]['to_days'] && this.agentData[ind]['to_days']){
       
      swal("PLEASE ENTER GREATER tHAN FROM VALUE!");
     this.agentData[ind]['to_days'] = '';
    }

   if(this.agentData[ind]['to_days']){
    this.agentData[ind+1]['from_days'] = parseInt(this.agentData[ind]['to_days']) + 1;
  }
  else{

    this.agentData[ind+1]['from_days'] = ''
  }
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({},ind);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }



  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getMasterAuto() {   
          this.salesservice.getMasterAuto({}).then((res: any) => {
            this.masterData.ref_no = res;
         
          });
           
  }
  tableStyle(ind){
     let color = ""
   if((ind % 2) == 1){
      color = "lightpink"
   }
   else{
    color = "bisque"
   }
   const style 
   ={
     background : color
   }
   return style
  }
  getAgentList() {
    let that = this;
    that.salesservice.getAgentList({}).then((res: any) => {
      this.list = res;
     
    });
  }

  onSelectTeam(type){
    let data = this.list;
    this.agentList = data.filter(el=>el.incharger == type);


  }
  getcommissionMasterList(){
    let that = this;
    that.salesservice.getcommissionMasterList({}).then((res: any) => {
      this.checklist = res.data;
      console.log(this.checklist);
       
    });

  }

    onSelectagent(type){
        let data = this.list;
        let obj = data.find(o => o.name === type);
         
           this.masterData.agent_id = obj.genLedid;

          let chekobj = this.checklist.filter(el=>el.agent_name == type);
            
            if(chekobj.length) {
              swal("NAME ALREADY EXIST!");
            }  

      }
    


      
      viewCommissionlist(com_id) {
        let params = {
          start: 0,
          limit: 100,
          page: 1,
          com_id:com_id,
        };
        this.salesservice
          .viewCommissionlist(params)
          .then((res: any) => {
            this.agentData = res.data;
            this.agentData[this.agentData.length-1]['to_days'] = '';
            // console.log(this.agentData);
            // this.calctot();
            // var bottom = document.querySelector("#salesTbody");
            // bottom.scrollTop = bottom.scrollHeight;
          });
      }
      // addValue(ind){
   

      // }  
 

  oncheckemptyrow() {
 
    let design = this.masterData;
    let empty_check = false;
  
      if(!design['ref_no'] || !design['date'] || !design['team'] || !design['agent'] || !design['effective_from']) {
        swal("PLEASE ENTER ALL THE DETAILS!");
        empty_check = true;
        // console.log(design['team'])
      }
    
    
    if(!empty_check){

      if(!this.agentData[this.agentData.length-1]['to_days']){
        this.agentData[this.agentData.length-1]['to_days'] = 1000
      }
      this.agentData[0]['per_detect'] = true;
    this.onSaveOrder();
    }
  }
   
   

  onSaveOrder() {
    // debugger;
    let params: any = Object.assign({}, this.masterData);
    params["date"] = this.datePipe.transform(
      this.masterData.date,
      "yyyy-MM-dd"
    );
    params["effective_from"] = this.datePipe.transform(
      this.masterData.effective_from,
      "yyyy-MM-dd"
    );
    params['agentData'] = JSON.stringify(this.agentData);
    params['mode'] = this.mode;
    // params["ret_date"] = this.datePipe.transform(
    //   this.masterData.ret_date,
    //   "yyyy-MM-dd"
    // );
      let that = this;
      that.isLoading = true;
      if (that.mode == "Add") {
        swal({
          title: "Are you sure to save this Details?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, save it!",
          cancelButtonText: "No, want to change",
        }).then(function () {
          that.isLoading = true;
          that.salesservice
          
            .addMasterCommission(params)
            .then(function (res: any) {
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                //    that.printdata(res.printData);
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        });
      } 
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/commissionMaster/addEditCommission.ts